<template>
	<div :class="$style.topbar">
		<template>
			<g-logo
				v-if="$settings.isMobileView || $settings.isMenuCollapsed"
				:dark="true"
			/>
			<g-project-logo
				v-else
				:dark="true"
			/>
		</template>

		<div
			v-if="$settings.custom.globalSearch"
			class="mb-0 ml-4"
		>
			<global-search />
		</div>

		<div class="mr-auto" />

		<chat v-if="$settings.custom.chat" />

		<update-check />

		<shortcuts />

		<air-user-menu />
	</div>
</template>

<script>
// import AirSearch from '@/system/layouts/app/topBar/Search';
import UpdateCheck from '@/system/layouts/app/topBar/UpdateCheck';
import AirUserMenu from '@/system/layouts/app/topBar/UserMenu';
import Chat from '@/system/layouts/public/chat';
import GlobalSearch from './GlobalSearch';

// import AirLanguageSwitcher from '@/system/layouts/TopBar/LanguageSwitcher';
// import AirActions from '@/system/layouts/TopBar/Actions';
// import AirIssuesHistory from '@/system/layouts/TopBar/IssuesHistory';

export default {
	components: {
		GlobalSearch,
		UpdateCheck,
		AirUserMenu,
		Chat
		// AirLanguageSwitcher,
		// AirActions,
		// AirIssuesHistory,
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
